import PortalToTarget from 'v3/common/components/PortalToTarget';

const KotakNeo = () => (
  <div id="stepper__container">
    <PortalToTarget targetClassName="login-modal__header" allowForWeb>
      <h3>Kotak API Setup: Consumer Key & TOTP Registration</h3>
    </PortalToTarget>

    <div className="stepper">
      {/* YouTube Guide */}
      <div className="mb-3 mx-3">
        <a
          className="text-decoration-underline"
          href="https://www.youtube.com/watch?v=pHti2oY3yKA"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/youtubeVideoTutorial.svg" style={{ cursor: 'pointer' }} alt="Kotak Neo YouTube Guide" />
        </a>
      </div>
      {/* Step 1: Get Consumer Key */}
      <li className="stepper_item" data-stepper="1">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 1: Get Consumer Key</h2>
          <ol>
            <li className="stepper_item" data-stepper="1">
              <div className="stepper_content">
                <p>
                  <b>Login</b> to{' '}
                  <a
                    className="text-decoration-underline"
                    href="https://neo.kotaksecurities.com/Login"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Neo app/web
                  </a>
                  .
                </p>
              </div>
            </li>
            <li className="stepper_item" data-stepper="2">
              <div className="stepper_content">
                <p>
                  Go to <b>Invest</b> tab → <b>TradeAPI</b> card.
                </p>
                <img
                  src="/images/broker_setup_guide/kotak_neo/step_2.png"
                  className="w-100"
                  alt="Invest tab → TradeAPI card"
                />
              </div>
            </li>
            <li className="stepper_item" data-stepper="3">
              <div className="stepper_content">
                <p>
                  <b>Open</b> API Dashboard and create an application (if not already done) and <b>Copy</b>{' '}
                  your <b>Consumer Key</b>
                </p>
                <img
                  src="/images/broker_setup_guide/kotak_neo/step_3.png"
                  className="w-100"
                  alt="API Dashboard"
                />
              </div>
            </li>
            <li className="stepper_item" data-stepper="4">
              <div className="stepper_content">
                <p>
                  <b>Paste</b> the Copied <b>Consumer Key</b> in the required field.
                </p>
                <img
                  src="/images/broker_setup_guide/kotak_neo/step_4.png"
                  className="w-100"
                  alt="Consumer Key"
                />
              </div>
            </li>
          </ol>
        </div>
      </li>

      {/* Step 2: Register TOTP */}
      <li className="stepper_item" data-stepper="2">
        <div className="stepper_content">
          <h2 className="stepper__heading">Step 2: Register TOTP</h2>
          <ol>
            <li className="stepper_item" data-stepper="1">
              <div className="stepper_content">
                <p>
                  Go to <b>Invest</b> tab → <b>TradeAPI</b> card → top right <b>Menu</b>, click{' '}
                  <b>TOTP Registration</b>.
                </p>
                <img
                  src="/images/broker_setup_guide/kotak_neo/step_5.png"
                  className="w-100"
                  alt="TOTP Registration"
                />
              </div>
            </li>
            <li className="stepper_item" data-stepper="2">
              <div className="stepper_content">
                <p>
                  Verify with your <b>mobile number</b>, <b>OTP</b>, and <b>client code</b>.
                </p>
                <img
                  src="/images/broker_setup_guide/kotak_neo/step_6.png"
                  className="w-100"
                  alt="Verify mobile"
                />
              </div>
            </li>
            <li className="stepper_item" data-stepper="3">
              <div className="stepper_content">
                <p>
                  Scan the <b>QR code</b> with Google/Microsoft Authenticator.
                </p>
                <img
                  src="/images/broker_setup_guide/kotak_neo/step_7.png"
                  className="w-100"
                  alt="Scan QR code"
                />
              </div>
            </li>
            <li className="stepper_item" data-stepper="4">
              <div className="stepper_content">
                <p>
                  Enter the generated <b>TOTP</b>.
                </p>
              </div>
            </li>
            <li className="stepper_item" data-stepper="5">
              <div className="stepper_content">
                <p>
                  Confirm “<b>TOTP successfully registered</b>”.
                </p>
              </div>
            </li>
            <li className="stepper_item" data-stepper="6">
              <div className="stepper_content">
                <p>
                  <b>
                    Enter the “<b>TOTP</b>” in the TOTP field.
                  </b>
                </p>
                <img
                  src="/images/broker_setup_guide/kotak_neo/step_8.png"
                  className="w-100"
                  alt="Enter TOTP"
                />
              </div>
            </li>
          </ol>
        </div>
      </li>

      {/* Final Step: Fill API credentials */}
      <li className="stepper_item" data-stepper="3">
        <div className="stepper_content">
          <h2 className="stepper__heading">
            Click the back button and fill the <b>Consumer Key</b> in the required field.
          </h2>
          <img src="/landing-page-img/brokers-img/last-step.png" alt="KotakNeo fill form" />
        </div>
      </li>
    </div>
  </div>
);

export default KotakNeo;
